import { useQuery } from 'react-query';
import { prospectStatusHistoryQuery } from './useProspectStatusHistory.query';
import { ProspectStatusHistory } from '../../../types/api/endpoints/prospect/prospect.types';

export const PROSPECTS_STATUS_HISTORY_QUERY_KEY = 'PROSPECTS_STATUS_HISTORY';

export const useProspectStatusHistory = (prospectId: number) => {
  return useQuery<ProspectStatusHistory[], Error>(
    PROSPECTS_STATUS_HISTORY_QUERY_KEY,
    () => prospectStatusHistoryQuery(prospectId),
    {
      cacheTime: 0,
      retry: true,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    }
  );
};
